import { Check, Minus } from "lucide-react";

export type ComparisonRow = {
	feature: string;
	competitor: string | boolean;
	agentreacher: string | boolean;
};

export function ComparisonTable({
	competitorName,
	rows,
}: {
	competitorName: string;
	rows: ComparisonRow[];
}) {
	return (
		<div className="mx-auto max-w-3xl overflow-x-auto">
			<table className="w-full text-sm">
				<thead>
					<tr className="border-b border-border">
						<th className="py-3 text-left font-medium text-foreground">
							Feature
						</th>
						<th className="py-3 text-left font-medium text-foreground">
							{competitorName}
						</th>
						<th className="py-3 text-left font-medium text-foreground">
							AgentReacher
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr key={row.feature} className="border-b border-border/50">
							<td className="py-3 text-foreground">{row.feature}</td>
							<td className="py-3 text-muted-foreground">
								<Cell value={row.competitor} />
							</td>
							<td className="py-3 text-foreground">
								<Cell value={row.agentreacher} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

function Cell({ value }: { value: string | boolean }) {
	if (value === true) return <Check className="size-4 text-primary" />;
	if (value === false) return <Minus className="size-4 text-muted-foreground/50" />;
	return <span>{value}</span>;
}
